<template>
  <div>
    <ClientOnly>
      <UPopover
        v-if="useTemplateStoreInstance.header.showPopover === true"
        v-model:open="open"
      >
        <template #anchor>
          <button
            :class="open ? ' ring-2 ring-primary-500 ring-offset-2' : ''"
            :aria-label="t('accessibility.userMenu')"
            class="rounded-full outline-none transition duration-200 ease-out focus-visible:ring-opacity-50 focus-visible:ring-primary-400 focus-visible:ring-3 focus-visible:outline-0 focus-visible:outline-none"
            @click.prevent="open = !open"
          >
            <div
              class="flex max-w-xs items-center bg-white text-sm h-8 w-8 rounded-full"
            >
              <span class="sr-only">{{ t('a11y.open-menu') }}</span>
              <AuthAvatar :compact="true" />
            </div>
          </button>
        </template>

        <template #content>
          <LazyRenderTemplatePopoverPanel />
        </template>
      </UPopover>
      <AuthHeader
        v-if="useTemplateStoreInstance.header.showPopover === false"
        :compact="true"
      />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import { useTemplateStore } from '~~/modules/template/stores/useTemplateStore'

const open = ref(false)

const useTemplateStoreInstance = useTemplateStore()
</script>
